import React, { useEffect, useRef } from 'react';
import { BoldIcon, ItalicIcon, TypeIcon } from 'lucide-react';
interface RichTextEditorProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
}
export function RichTextEditor({
  label,
  value,
  onChange,
  placeholder = '',
  rows = 3
}: RichTextEditorProps) {
  const editorRef = useRef<HTMLDivElement>(null);
  // Initialize content
  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);
  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };
  const applyFormat = (command: string, value?: string) => {
    document.execCommand(command, false, value);
    editorRef.current?.focus();
    handleInput();
  };
  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text/plain');
    document.execCommand('insertText', false, text);
  };
  return <div data-id="element-724" data-mp="3p22eymy5qm4d">
      <label className="block text-sm font-medium text-stone-700 mb-1.5" data-id="element-725" data-mp="3p2bu1fhnz8va">
        {label}
      </label>

      {/* Formatting Toolbar */}
      <div className="flex items-center gap-1 mb-2 p-2 bg-stone-50 border border-stone-200 rounded-lg" data-id="element-726" data-mp="3g8h0l4pwn6vh">
        <button type="button" onClick={() => applyFormat('bold')} className="p-2 hover:bg-stone-200 rounded transition-colors" title="Fed (Ctrl+B)" data-id="element-727" data-mp="3k8hg6soqpo44">
          <BoldIcon className="w-4 h-4 text-stone-700" data-id="element-728" data-mp="3b8ujgk6yh6he" />
        </button>

        <button type="button" onClick={() => applyFormat('italic')} className="p-2 hover:bg-stone-200 rounded transition-colors" title="Kursiv (Ctrl+I)" data-id="element-729" data-mp="2x93003xo6xw0">
          <ItalicIcon className="w-4 h-4 text-stone-700" data-id="element-730" data-mp="vhq0xvidvk7v" />
        </button>

        <div className="w-px h-6 bg-stone-300 mx-1" data-id="element-731" data-mp="vflxfeoecn84" />

        <button type="button" onClick={() => applyFormat('fontSize', '3')} className="px-2 py-1 hover:bg-stone-200 rounded transition-colors text-xs font-medium text-stone-700" title="Lille tekst" data-id="element-732" data-mp="zhqny4jjt3qj">
          S
        </button>

        <button type="button" onClick={() => applyFormat('fontSize', '4')} className="px-2 py-1 hover:bg-stone-200 rounded transition-colors text-sm font-medium text-stone-700" title="Normal tekst" data-id="element-733" data-mp="1zesdjaqgsoge">
          M
        </button>

        <button type="button" onClick={() => applyFormat('fontSize', '5')} className="px-2 py-1 hover:bg-stone-200 rounded transition-colors text-base font-medium text-stone-700" title="Stor tekst" data-id="element-734" data-mp="2n4v39k6wpibu">
          L
        </button>

        <button type="button" onClick={() => applyFormat('fontSize', '6')} className="px-2 py-1 hover:bg-stone-200 rounded transition-colors text-lg font-medium text-stone-700" title="Meget stor tekst" data-id="element-735" data-mp="2dcz0vwxsf61t">
          XL
        </button>
      </div>

      {/* Editable Content */}
      <div ref={editorRef} contentEditable onInput={handleInput} onPaste={handlePaste} className="w-full px-4 py-2.5 rounded-lg border border-stone-200 bg-white text-stone-900 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all overflow-auto" style={{
      minHeight: `${rows * 1.5}rem`,
      maxHeight: '300px'
    }} data-placeholder={placeholder} data-id="element-736" data-mp="3idq7joor5a33" />

      <style data-id="element-737" data-mp="55dca9jzyxfn">{`
        [contenteditable]:empty:before {
          content: attr(data-placeholder);
          color: #9ca3af;
          pointer-events: none;
        }
        [contenteditable] {
          white-space: pre-wrap;
          word-wrap: break-word;
        }
      `}</style>
    </div>;
}